enum ProductTypes {
  Stock = 'Stock',
  Custom = 'VC',
  Eto = 'ETO',
  Imagen = 'Imagen',
}

export default ProductTypes;
